import { set } from 'cerebral/operators'
import { state } from 'cerebral/tags'

export default [set(state`media.dragging`, true)]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onDragBeginHook.js